export interface CountryStaticData {
  flagCode: string;
  description: string;
  rules: string[];
}

export const vignetteStaticData: Record<string, CountryStaticData> = {
  AT: {
    flagCode: 'at',
    description:
      'Austria requires a digital vignette (e-vignette) for all motorways and expressways. The vignette is linked to your license plate and checked automatically via cameras. No physical sticker needed.',
    rules: [
      'Valid immediately after purchase',
      'Linked to license plate — no sticker',
      'Motorways A and S roads covered',
    ],
  },
  HU: {
    flagCode: 'hu',
    description:
      'Hungary uses the e-Matrica system. All vehicles need a digital vignette to use motorways (M roads). The vignette is tied to the license plate and enforced with ANPR cameras.',
    rules: [
      'Valid from the selected start date',
      'All M and some main roads covered',
      'Motorcycles are exempt',
    ],
  },
  CH: {
    flagCode: 'ch',
    description:
      'Switzerland requires an annual motorway vignette. There is no short-term option — the vignette is valid from December of the previous year until January of the following year.',
    rules: [
      'Annual vignette only',
      'Valid on all motorways (Autobahn)',
      'Price set by Swiss government',
    ],
  },
  CZ: {
    flagCode: 'cz',
    description:
      'Czechia uses the e-dálniční známka system. A digital vignette is required for motorways and selected first-class roads. The vignette is registered to the license plate.',
    rules: [
      'Valid on D and R roads',
      'Start date can be set in advance',
      'Trailers may need a separate vignette',
    ],
  },
  SK: {
    flagCode: 'sk',
    description:
      'Slovakia requires an e-vignette (elektronická známka) for motorways and expressways. The system is fully digital and tied to the license plate number.',
    rules: [
      'Valid on D and R class roads',
      'ANPR enforcement nationwide',
      'Trailers over 3.5t need vignette',
    ],
  },
  SI: {
    flagCode: 'si',
    description:
      'Slovenia uses the DARS e-vignette system. Digital vignettes are required for motorways and expressways. The vignette is linked to the license plate and enforced via cameras.',
    rules: [
      'Valid on all motorways (A) and expressways (H)',
      'Start date selectable',
      'Motorcycles are exempt',
    ],
  },
  RO: {
    flagCode: 'ro',
    description:
      'Romania uses the Rovinieta system. All vehicles need a digital vignette for motorways and national roads. The vignette is tied to the license plate and checked with ANPR.',
    rules: [
      'Valid on motorways and selected national roads',
      'Can be purchased up to 30 days in advance',
      'Trailers need separate vignette',
    ],
  },
  BG: {
    flagCode: 'bg',
    description:
      'Bulgaria requires an e-vignette (e-vinetka) for motorways, expressways, and selected first-class roads. The system is digital and linked to the license plate.',
    rules: [
      'Valid on A and selected roads',
      'Purchase at least 1 day before travel',
      'Motorcycles are exempt',
    ],
  },
};
